export const LOCALSTORAGE_POSITION_KEY = 'vg_pos';
export const LOCALSTORAGE_INVENTORY_KEY = 'vg_inv';
export const LOCALSTORAGE_CHAPTERS_KEY = 'vg_cha';
export const LOCALSTORAGE_TASK_KEY = 'vg_tas';
export const LOCALSTORAGE_SOUNDSCAPE_KEY = 'vg_ssc';
export const LOCALSTORAGE_FOOTSTEPS_KEY = 'vg_foo';
export const LOCALSTORAGE_JOURNAL_KEY = 'vg_jou';

export const START_POSITION = { lat: -20.44995, lng: -69.50578 };
export const START_POV = { heading: 279.83396999258559, pitch:  -1.184891582816434 };

export const MAPS_API_KEY = 'AIzaSyA1VOiLnJEwz3HzcDxEExa_tCTu5KKOoqQ';

export const OBJECT_APPEAR_THRESHOLD = 10;
export const OBJECT_LOAD_THRESHOLD = 40;

export const DEFAULT_COLLECT_TEXT = 'Collected';

export const HITCHHIKE_PANO = 'REjdyk2fgnf3LWBQudZiGg';

export const ANIMITAS_ENDPOINT = process.env.NODE_ENV === 'dev'
  ? 'http://localhost:8787'
  : 'https://animitas.finding-gustavo.quest';
